export const state = {
  tarrifs: [],
  systemTarrif: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/tarrifs/state.js